import { kebabCase } from 'lodash';

export const convertPropsToCssRules = <T>(keys: (keyof T)[]) => (props: T): string => {
  let result = '';
  keys.forEach((key): void => {
    if (props[key]) {
      if (typeof props[key] === 'string' || typeof props[key] === 'number') {
        result += `${kebabCase(key.toString())}: ${props[key]};\n`;
        return;
      }
      Object.entries(props[key]).forEach(([insideKey, value]) => {
        result += `${kebabCase(insideKey.toString())}: ${value};\n`;
      });
    }
  });
  return result;
};
